module.exports = __webpack_public_path__ + "img/tensile_test.622a787e.jpg";